<template>
    <div>
        <div v-if="initialLoadInProgress">
            <Spinner
                class="mt-32"
                appearance="dots"
                size="xl"
                color="black"
            ></Spinner>
        </div>
        <div v-else>
            <EmptyFeed v-if="emptyFeed">
                <template #header>
                    {{ t('profile:emptyFeed.document.header') }}
                </template>
                <template #image>
                    <img
                        class="w-48 mx-auto"
                        :src="emptyStateImage"
                    />
                </template>
                <template #title>
                    {{ t('profile:emptyFeed.document.text_1') }}
                </template>
                <template #text>
                    {{ t('profile:emptyFeed.document.text_2') }}
                </template>
            </EmptyFeed>

            <div v-if="documentsTotalCount > 0">
                <div class="mx-auto my-0">
                    <div class="px-4 pt-4 md:px-0">
                        <DocumentListItem
                            v-for="document in documentsList"
                            :key="document.id"
                            class="mb-4 md:mb-6"
                            :document="document"
                            :context="'profile-page'"
                        ></DocumentListItem>
                    </div>

                    <!-- native modifier has been removed, please confirm whether the function has been affected  -->

                    <BtnCta
                        v-if="documentsCanLoadMore"
                        variant="secondary"
                        class="mx-auto my-0"
                        :label="t('loadMore')"
                        :disabled="inProgress"
                        @click="loadMore"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EmptyFeed from '@components/EmptyFeed';
import DocumentListItem from '@components/DocumentListItem';
import { useTranslation } from 'i18next-vue';

export default {
    name: 'ProfileShowDocuments',
    components: {
        EmptyFeed,
        DocumentListItem,
    },
    props: {
        userId: {
            type: Number,
            required: true,
        },
        followedOnly: {
            type: Boolean,
            default: false,
        },
    },
    setup() {
        const { t } = useTranslation('profile');
        return { t };
    },
    data() {
        return {
            emptyFeed: false,
            initialLoadInProgress: true,
            inProgress: false,
        };
    },
    computed: {
        ...mapGetters('profile', [
            'documentsList',
            'documentsPage',
            'documentsCanLoadMore',
            'documentsTotalCount',
        ]),
        emptyStateImage() {
            return '/images/mascots/sleep.png';
        },
    },
    created() {
        this.getDocuments(1, false, this.followedOnly);
    },
    methods: {
        getDocuments(page, shouldAppendResult, followed) {
            this.inProgress = true;
            this.$store
                .dispatch('profile/retrieveDocuments', {
                    id: this.userId,
                    page,
                    shouldAppendResult,
                    followed,
                })
                .then(() => {
                    if (this.initialLoadInProgress && this.documentsTotalCount === 0) {
                        this.emptyFeed = true;
                    }
                })
                .finally(() => {
                    this.inProgress = false;
                    this.initialLoadInProgress = false;
                });
        },
        loadMore() {
            if (!this.inProgress) {
                this.getDocuments(this.documentsPage + 1, true, this.followedOnly);
            }
        },
    },
};
</script>
